<template>
  <div class="productcenter3html">
    <div class="productcenter3head">
      <div class="productcenter3headtext">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 24px;
          "
        >
          产业数据
        </p>
        <p
          style="
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            letter-spacing: 1px;
            white-space: nowrap;
          "
        >
          对品种进行全方位、全链条整合，以线图形式展示品种画像、供应/需求端、现货、资金面...，使产业信息更精准、高效的定位核心价值点。
        </p>
      </div>
    </div>
    <div class="productcenter3body">
      <div class="productcenter3bodytag">
        <ul style="padding-top: 70px">
          <li class="pli">
            <div v-bind:class="[form.oneth ? class4 : class3]"></div>
            <div v-bind:class="[form.oneth ? class1 : class5]" @click="oneth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">品种画像</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.twoth ? class4 : class3]"></div>
            <div v-bind:class="[form.twoth ? class1 : class2]" @click="twoth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">供应端追踪</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.threeth ? class4 : class3]"></div>
            <div
              v-bind:class="[form.threeth ? class1 : class2]"
              @click="threeth"
            >
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid" style="width: 145px">需求端追踪</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fourth ? class4 : class3]"></div>
            <div v-bind:class="[form.fourth ? class1 : class2]" @click="fourth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">现货</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
          </li>
          <li class="pli">
            <div v-bind:class="[form.fiveth ? class4 : class3]"></div>
            <div v-bind:class="[form.fiveth ? class1 : class2]" @click="fiveth">
              <div style="width: 45px; height: 40px; float: left"></div>
              <div class="tagmid">资金面</div>
              <div style="width: 30px; height: 40px; float: left"></div>
            </div>
          </li>
        </ul>
      </div>
      <div class="productcenter3bodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="form.oneth">
              <h4 class="head4" id="productcenter3one">一、品种画像</h4>
              <p class="pproduct">
                包括品种的基本信息、上下游产业链、历史上的大事记和重要数据及事件预告。
              </p>
              <p class="pproduct">
                <span>1、品种概览：</span
                >展示品种的属性、用途、供应与消费分布及其他影响价格的因素。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-1.jpg" /></p>
              <p class="pproduct">
                <span>2、产业链导图：</span
                >以思维导图的形式展示产业链上下游的关系，一张图呈现“从哪里来”和“到哪里去”。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-2.jpg" /></p>
              <p class="pproduct">
                <span>3、大事记：</span
                >以时间轴的方式展示历史上重要的风险事件，错过的大事在这里追回。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-3.jpg" /></p>
              <p class="pproduct">
                <span>4、品种日历：</span
                >直观的日历日程，重要数据信息发布时间尽在掌握，未来风险事件提前知道，领先一步做好风险管理。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-4.jpg" /></p>
            </div>
            <div v-if="form.twoth">
              <h4 class="head4" id="productcenter3two">二、供应端追踪</h4>
              <p class="pproduct">
                通过图表与具体数据结合，揭示当前供应端状态。
              </p>
              <p class="pproduct">
                提供的深度数据包括，产量、进口、开工率、库存等。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-5.jpg" /></p>
            </div>
            <div v-if="form.threeth">
              <h4 class="head4" id="productcenter3three">三、需求端追踪</h4>
              <p class="pproduct">
                通过图表与具体数据结合，揭示当前需求端状态。
              </p>
              <p class="pproduct">提供的深度数据包括，消费、出口、开工率等。</p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-6.jpg" /></p>
            </div>
            <div v-if="form.fourth">
              <h4 class="head4" id="productcenter3four">四、现货</h4>
              <p class="pproduct">
                提供主要地区权威现货报价、主力基差、利润及其它价差分析，能够迅速捕捉现货市场价格、利润等变动，为您做趋势判断、套利分析提供有效参考。
              </p>
              <p class="pproduct">
                <span>1、现货价格：</span
                >以交割标的物为中心，相关替代品为扩展，多层次展示主流现货价格。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-7.jpg" /></p>
              <p class="pproduct">
                <span>2、价差：</span
                >现货和期货主力基差及其它价差分析，结合盘面报价，洞悉期现回归的脉搏。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-8.jpg" /></p>
            </div>
            <div v-if="form.fiveth">
              <h4 class="head4" id="productcenter3five">五、资金面</h4>
              <p class="pproduct">
                提供历史资金流向，沉淀资金，持仓龙虎榜，席位建仓过程及外盘CFTC持仓数据，可以全方位的分析市场资金及主力动向。
              </p>
              <p class="pproduct">
                <span>1、沉淀资金和资金流向：</span
                >最新及历史沉淀资金和资金流向，行情异动下的市场热度和资金变化一览无余。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-9.jpg" /></p>
              <p class="pproduct">
                <span>2、持仓龙虎榜：</span
                >每日期货持仓数据,跟踪期货主力动向,识别主力机构的期货持仓结构。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-10.jpg" /></p>
              <p class="pproduct">
                <span>3、建仓过程：</span
                >展示期货公司席位在该品种的建仓过程，追随主力脚步，踩准行情节拍。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-11.jpg" /></p>
              <p class="pproduct">
                <span>4、CFTC持仓：</span
                >基金在外盘期货上的多空力量对比以及净头寸的变化，提前把脉外盘行情变化。
              </p>
              <p class="pimg"><img src="@/../public/proimg3/prd3-12.jpg" /></p>
              <h4 class="head4">调出模块</h4>
              <p class="pproduct">
                方法1：国内商品分时图/k线图，在左侧导航条中选择【产业数据】；
              </p>
              <p class="pproduct">方法2：电脑键盘上直接点击F9调出。</p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        oneth: true,
        twoth: false,
        threeth: false,
        fourth: false,
        fiveth: false,
      },
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
      scroll: "",
    };
  },
  methods: {
    custormAnchor(anchorName) {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });

      this.form[anchorName + "th"] = true;
    },
    oneth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.oneth = true;
      var id = "one";
      this.$router.push({ path: `/proc/productcenter3/${id}` });
      this.custormAnchor(id);
    },
    twoth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.twoth = true;
      var id = "two";
      this.$router.push({ path: `/proc/productcenter3/${id}` });
      this.custormAnchor(id);
    },
    threeth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.threeth = true;
      var id = "three";
      this.$router.push({ path: `/proc/productcenter3/${id}` });
      this.custormAnchor(id);
    },
    fourth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fourth = true;
      var id = "four";
      this.$router.push({ path: `/proc/productcenter3/${id}` });
      this.custormAnchor(id);
    },
    fiveth() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
      this.form.fiveth = true;
      var id = "five";
      this.$router.push({ path: `/proc/productcenter3/${id}` });
      this.custormAnchor(id);
    },
    zero() {
      Object.keys(this.form).forEach((item) => {
        this.form[item] = false;
      });
    },

    menu(e) {
      if (
        e.target.scrollTop >=
          document.querySelector("#productcenter3one").offsetTop &&
        document.querySelector("#productcenter3two").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.oneth = true;
        var id1 = "productcenter3one";
        this.$router.push({ path: `/proc/productcenter3/${id1}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenter3two").offsetTop &&
        document.querySelector("#productcenter3three").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.twoth = true;
        var id2 = "productcenter3two";
        this.$router.push({ path: `/proc/productcenter3/${id2}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenter3three").offsetTop &&
        document.querySelector("#productcenter3four").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.threeth = true;
        var id3 = "productcenter3three";
        this.$router.push({ path: `/proc/productcenter3/${id3}` });
      } else if (
        e.target.scrollTop >=
          document.querySelector("#productcenter3four").offsetTop &&
        document.querySelector("#productcenter3five").offsetTop >
          e.target.scrollTop
      ) {
        this.zero();
        this.form.fourth = true;
        var id4 = "productcenter3four";
        this.$router.push({ path: `/proc/productcenter3/${id4}` });
      } else {
        if (this.form.fiveth == true) {
          this.zero();
          this.form.fiveth = true;
          var id11 = "productcenter3five";
          this.$router.push({ path: `/proc/productcenter3/${id11}` });
        } else {
          this.zero();
          this.form.fiveth = true;
          var id10 = "productcenter3five";
          this.$router.push({ path: `/proc/productcenter3/${id10}` });
        }
      }
    },
  },

  mounted() {
    this.custormAnchor(this.$route.params.id);
  },
};
</script>

<style scoped>
.productcenter3html {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat center;
  background-size: 100% 100%;
  min-width: 1400px;
  width: 100%;
}
.productcenter3head {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenter3headtext {
  position: absolute;
  top: 90px;
}
.productcenter3body {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenter3bodytag {
  width: 580px;
  height: 630px;
  border-radius: 2%;
  background: url("../../assets/images/ts-4_01.png") no-repeat center;
  background-size: 100% 100%;
  display: inline-block;
}
.productcenter3bodytext {
  width: 780px;
  margin-top: -614px;
  margin-left: 220px;
  min-height: 680px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-1_02.jpg") no-repeat top, #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #c2c5d4);
  display: inline-block;
}
.noclick {
  height: 41px;
  line-height: 41px;

  width: 220px;
  border-top: 1px solid #97c9d9;
  letter-spacing: 1px;
  color: #26353a;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;

  color: #26353a;
  text-align: left;
  letter-spacing: 1px;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #e3a200;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #285b6b;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  width: 680px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-indent: 2em;
  color: #727983;
  line-height: 25px;
  /* width: 640px; */
  text-align: justify;
  letter-spacing: 1px;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.pimg img {
  width: 90%;
}
.noclick:hover {
  color: #c2edfb;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #97c9d9;
  color: #26353a;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-top: 1px solid #2f5476;
  border-bottom: 1px solid #2f5476;
  color: #85c0ea;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #c2edfb;
}
.noclickele:hover {
  color: #c2edfb;
}
.tagmid {
  width: 130px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.head5 {
  color: #245376;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
</style>